export default __webpack_public_path__ + "static/media/5F243572-2AE9-4468-8E83-0BCF6F2D5800.fe24785d.jpeg";